/**
 * Returns account data if Accounts domain is valid
 *
 * @param domain Accounts domain, can be empty
 * @returns Data if domain is not empty, otherwise null
 */
export const getAllAccounts = (domain) => { var _a; return (_a = domain === null || domain === void 0 ? void 0 : domain.data) !== null && _a !== void 0 ? _a : null; };
//# sourceMappingURL=selectors.js.map